import { Injectable } from '@angular/core';
import { LoggingConstants } from './../../constants/logging-constant';
import { UIStorageService } from './../storage.service';
// import { RemoteService } from './../remote.service';
import { AppUtility } from '../../utils/utility';
import { IUrlOptions } from './../../models/rest.caller.model';
import { AppStartupService } from './../app-startup';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoggingStartupConfigService } from './logging-startup';
import { DomStorageFallbackService } from './../DomStorageFallback.service';
import { map } from 'rxjs/operators';
declare var navigator;

/**
 * Core Service for logging different
 * levels of logs through application.
 */
// @dynamic
@Injectable()
export class LoggingService {
    public static uConsole = false;
    static lr_json_data;
    private renewSessionBufferLoggingCalls: any[] = [];
    private GatewayURL: string = '';
    private appURL: string = '';

    // Array for holding different level of logs.
    /* istanbul ignore next */
    constructor(private appUtility: AppUtility, private http: HttpClient, private logStartupConfig: LoggingStartupConfigService, private domStorageFB: DomStorageFallbackService) {
        try {
            LoggingService.lr_json_data = JSON.parse(this.domStorageFB.getItem('lr_json_data'));
        } catch (error) {
            // No Logging possible since the constructor failed to get endpoints
        }
        try {
            // tslint:disable-next-line:max-line-length
            if ((this.domStorageFB.getItem('enableDynamicURL') === null || this.domStorageFB.getItem('enableDynamicURL') === 'null') || (this.domStorageFB.getItem('enableDynamicURL') === false || this.domStorageFB.getItem('enableDynamicURL') === 'false')) {
                this.GatewayURL = this.domStorageFB.getItem('gatewayUrl');
            } else {
                if (!this.domStorageFB.getItem('gatewayUrlOverridden')) {
                    let newApiUrl = this.appUtility.getUpointNextUrl();
                    newApiUrl = newApiUrl + '/alightapi/api/';
                    this.GatewayURL = newApiUrl;
                } else {
                    this.GatewayURL = this.domStorageFB.getItem('gatewayUrl');
                }
            }
        } catch (error) {
            // No Logging possible since the constructor failed to get endpoints
            this.GatewayURL = null;
        }

        let app_url = './';
        try {
            app_url = this.domStorageFB.getItem('app_url');
            if (app_url === null) {
                app_url = './';
            }
            this.appURL = app_url;
        } catch (error) {
            // No Logging possible since the constructor failed to get endpoints
        }
    }

    /* istanbul ignore next */
    private checkLRJsonData() {
        if (UIStorageService.lr_json_data === null) {
            UIStorageService.lr_json_data = JSON.parse(this.domStorageFB.getItem('lr_json_data'));
        }
    }

    /* istanbul ignore next */
    public getClientId() {
        try {
            let alightRequestHeader;
            let clientId;
            if (this.domStorageFB.getItem('alightRequestHeader')) {
                alightRequestHeader = JSON.parse(this.domStorageFB.getItem('alightRequestHeader'));
                if (alightRequestHeader.clientId) {
                    clientId = alightRequestHeader.clientId;
                    return clientId;
                } else {
                    return JSON.parse(this.domStorageFB.getItem('lr_json_data')).lineage.split('_')[0];
                }
            }
        } catch (error) { return null; }
    }

    /* istanbul ignore next */
    public getCompanyId() {
        try {
            this.checkLRJsonData();
            return UIStorageService.lr_json_data.companyid;
        } catch (error) { return null; }
    }

    /* istanbul ignore next */
    public getLineage() {
        try {
            this.checkLRJsonData();
            return UIStorageService.lr_json_data.lineage;
        } catch (error) { return null; }
    }

    /* istanbul ignore next */
    public getOrgId() {
        try {
            this.checkLRJsonData();
            return UIStorageService.lr_json_data.orgid;
        } catch (error) { return null; }
    }

    /* istanbul ignore next */
    public getGroupId() {
        try {
            this.checkLRJsonData();
            return UIStorageService.lr_json_data.groupid;
        } catch (error) { return null; }
    }

    /* istanbul ignore next */
    public getUser() {
        try {
            this.checkLRJsonData();
            return UIStorageService.lr_json_data.userDetails;
        } catch (error) { return null; }
    }

    /**
    * Method for logging Usage interactions
    * level log through application
    */
    /* istanbul ignore next */
    _usage(message: string, resourceName: string, resourceInstance: string, userAction: string, severityLevel: string, requestType: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, consumerRefID: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL) {
        // console.log(' in log usage tracing  ');
        if (this.isValidLogLevel(severityLevel, LoggingConstants.EVENT_TYPE_USAGE_LABEL)) {
            this.sendLogDataToServer(this.generateLogData(LoggingConstants.EVENT_TYPE_USAGE_LABEL, message, resourceName, resourceInstance, severityLevel, userAction, requestType, consumerRefID));
        }
    }

    /**
    * Method for logging Page Usage
    * level log through application
    */
    /* istanbul ignore next */
    _pageUsage(message: string, resourceName: string, resourceInstance: string, userAction: string, severityLevel: string, requestType: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, pageUsageAttributes?: any) {
     // console.log(' in log _pageUsage tracing  ');
      if (this.isValidLogLevel(severityLevel, LoggingConstants.EVENT_TYPE__PAGEUSAGE_LABEL)) {
       // console.log(' in log _pageUsage tracing  severityLevel' , severityLevel);
            this.sendLogDataToServer(this.generateLogData(LoggingConstants.EVENT_TYPE__PAGEUSAGE_LABEL, message, resourceName, resourceInstance, severityLevel, userAction, requestType, '', '', '', '', pageUsageAttributes));
        }
    }

    /**
    * Method for logging Error
    * level log through application
    */
    /* istanbul ignore next */
    _error(message: string, resourceName: string, severityLevel: string, resourceInstance: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL) {
        if (this.isValidLogLevel(severityLevel, LoggingConstants.EVENT_TYPE_ERROR_LABEL)) {
            this.sendLogDataToServer(this.generateLogData(LoggingConstants.EVENT_TYPE_ERROR_LABEL, message, resourceName, resourceInstance, severityLevel));
        }
    }

    /**
    * Method for logging Debug
    * level log through application
    */
    /* istanbul ignore next */
    _debug(message: string, resourceName: string, severityLevel: string, resourceInstance: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL) {
        if (this.isValidLogLevel(severityLevel, LoggingConstants.EVENT_TYPE_DEBUG_LABEL)) {
            this.sendLogDataToServer(this.generateLogData(LoggingConstants.EVENT_TYPE_DEBUG_LABEL, message, resourceName, resourceInstance, severityLevel));

        }
    }

    /**
    * Method for logging screen capture
    * level log through application
    */
    /* istanbul ignore next */
    _uxScreenCapture(message: string, resourceName: string, severityLevel: string, resourceInstance: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, zipAlgorithm: string, actionDescription: any, pagePayLoad: any) {
        let enableScrnCaptureFlag = this.domStorageFB.getItem('enableScreenCapture', '', true);
        let clientParmFlag = this.domStorageFB.getItem('IS_SCREEN_CAPTURE_ON', '', true);
        if (enableScrnCaptureFlag && enableScrnCaptureFlag === 'true' && clientParmFlag && clientParmFlag === 'true') {
            if (this.isValidLogLevel(severityLevel, LoggingConstants.EVENT_TYPE__UXSCREENCAPTURE_LABEL)) {
                // tslint:disable-next-line:max-line-length
                this.sendLogDataToServer(this.generateLogData(LoggingConstants.EVENT_TYPE__UXSCREENCAPTURE_LABEL, message, resourceName, resourceInstance, severityLevel, 'pageview', '', '', zipAlgorithm, actionDescription, pagePayLoad));
            }
        }
    }

    /**
    * Method for logging UX Render Event
    */
    /* istanbul ignore next */
    /* _uxRenderEvent(message: string, resourceName: string, resourceInstance: string, userAction: string, severityLevel: string, requestType: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, pageUsageAttributes?: any) {
        if (this.isValidLogLevel(severityLevel, LoggingConstants.EVENT_TYPE__RENDEREVENTS_LABEL)) {
            this.sendLogDataToServer(this.generateLogData(LoggingConstants.EVENT_TYPE__RENDEREVENTS_LABEL, message, resourceName, resourceInstance, severityLevel, userAction, requestType, '', '', '', '', pageUsageAttributes));
        }
    } */

    // added for Getting Locale details from session storage.

    /* istanbul ignore next */
    public getLocale() {
        try {
            this.checkLRJsonData();
            return UIStorageService.lr_json_data.locale;
        } catch (error) { return null; }
    }

    /* istanbul ignore next */
    public uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable-next-line:no-bitwise
            let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    /**
     * Function for generating log Data as per log level.
     * @param logLevel
     * @param message
     */
    /* istanbul ignore next */
    private generateLogData(logLevel: string, message: string, resourceName: string, resourceInstance: string, severityLevel: string, userAction: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, requestType: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, consumerReferenceId: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, zipAlgorithm: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, actionDescription: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, pagePayload: any = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL, pageUsageAttributes?: any) {
        let activeRouteUrl = window.location.href;
        let windowUrl = '';
        if (activeRouteUrl.indexOf('?') === -1) {
            windowUrl = activeRouteUrl;
        } else {
            windowUrl = activeRouteUrl.substr(0, activeRouteUrl.indexOf('?'));
        }
        let logData = [{
            Time: new Date().getTime(),
            EventType: logLevel,
            ResourceName: this.checkObjData(resourceName) + ' - ' + windowUrl,
            ResourceInstance: this.checkObjData(resourceInstance),
            UserAction: userAction,
            Lifecycle: this.GatewayURL, // .fetchStorageValueByKey('gatewayUrl'),
            Host: this.appURL, // .fetchStorageValueByKey('app_url'),
            ClientId: this.getClientId(),
            ExternalRefID: (consumerReferenceId == null || consumerReferenceId === '') ? this.uuid() : consumerReferenceId,
            Locale: this.getLocale(),
            UserAgent: navigator.userAgent,
            SrcIP: LoggingConstants.GLOBAL_SRC_IP_VALUE,
            Severity: severityLevel,
            Message: this.checkObjData(message),
            RequestType: requestType,
            GlobalSessionID: this.logStartupConfig.getGlobalSessionID(),
            AppVersion: this.domStorageFB.getItem('appVersion', 'localStorage', true),
            UxPageRequestId: this.domStorageFB.getItem('uniquePageId', '', true),
            PageName: this.appUtility.getPageNameFromURL(),
            DeviceType: this.domStorageFB.getItem('upointDeviceType', '', true),
            SessionCreatedTimestamp: this.domStorageFB.getItem('sessionCreatedTimestamp', 'sessionStorage', true),
            ...pageUsageAttributes
        }];

        if (logLevel === LoggingConstants.EVENT_TYPE__UXSCREENCAPTURE_LABEL) {
            logData[0]['ZipAlgorithm'] = zipAlgorithm;
            logData[0]['PagePayload'] = pagePayload;
            logData[0]['ActionDescription'] = actionDescription;
        }

        return logData;
    }

    /**
     * Function for checking passed
     * message data is valid or not.
     * @param msg
     */
    /* istanbul ignore next */
    checkObjData(msg) {
        if (!msg || msg === 'null' || msg === null || msg === 'undefined') {
            return '';
        }
        if (typeof msg === 'object') {
            for (const key in msg) {
                if (msg.hasOwnProperty(key)) {
                    return JSON.stringify(msg);
                }
            }
            return '';
        }
        return msg;
    }


    /**
     * Function for sending log Data to
     * server for logging purpose.
     * @param logData
     */
    /* istanbul ignore next */
    private sendLogDataToServer(logData: any) {
        let urlOptions: IUrlOptions = {
            restOfUrl: '',
            endPoint: LoggingConstants.LOGGING_POST_SERVER_ENDPOINT_URL, isSecure: true, contentType: 'application/json'
        };

        try {
            if (!LoggingConstants.IS_LOGGING_LOCAL_ENABLED) {
                let _headers = new HttpHeaders();
                _headers = this.getHeadersData(urlOptions);
                let options = { headers: _headers };
                let endPointUrl = this.constructUrl(urlOptions);
                let token = null;
                if (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true))) {
                    token = this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true);
                } else if (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true))) {
                    token = this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true);
                }

                let isSessionRenewInProgress = this.domStorageFB.getItem('sessionRenewInProgress');

                if (endPointUrl && token && this.domStorageFB.isValidToken(this.domStorageFB.getItem('alightRequestHeader')) && isSessionRenewInProgress && isSessionRenewInProgress === 'false') {
                    return this.http.post(endPointUrl, logData, options).
                        subscribe((res) => {
                        }, err => {
                            // if (console)
                            // console.error(" Error while logging to server ", err);
                            // Added for renewSession functionality while logging call started here
                            // if (err.status === 401) {
                            //     this.renewSessionBufferLoggingCalls.push({
                            //         urlOptions,
                            //         logData
                            //     });
                            //     let sessionRenewInProgress = sessionStorage.getItem('sessionRenewInProgress');
                            //     if (sessionRenewInProgress === 'false') {
                            //         this.renewSessionForLogging();
                            //         sessionStorage.setItem('sessionRenewInProgress', 'true');
                            //     }
                            // }
                            if (LoggingService.uConsole) {
                                console.log('Error in event logs ', err);
                            }
                            // Added for renewSession functionality while logging call ends here
                        });
                }
            } else {
                // In case of local logging enabled then log would be visible on console.
                if (console) { console.log('Log data: ', logData); }
            }
        } catch (error) { }

    }

    /**
     * Function for creating Http url endpoint based on session storage value.
     * @param urlOptions
     */
    /* istanbul ignore next */
    private constructUrl(urlOptions: IUrlOptions): string {
        return this.GatewayURL + urlOptions.endPoint + urlOptions.restOfUrl + '/';
    }

    /**
     * isValidLogLevel
     * Function for verification of valid log severity level.
     */
    /* istanbul ignore next */
    private isValidLogLevel(severityLevel: string, logEventlevel: string): boolean {

        if (LoggingConstants.IS_LOGGING_LOCAL_ENABLED) {
            // Added for handling local logging enabling
            return true;
        }

        let logLevel = this.logStartupConfig.getLoggingConfigLevel();
        if ((LoggingStartupConfigService.logHierarchyOrderMap.get(logLevel[logEventlevel]).indexOf(severityLevel)) !== -1) {
            return true;
        }
        return false;
    }

    /**
     * private renewSessionForLogging() {
     * Function for renew session while logging to server.
     * */
    /* istanbul ignore next */
    /* tslint:disable-next-line */
    private renewSessionForLogging() {

        let urlOptions: IUrlOptions = {
            restOfUrl: '',
            endPoint: 'renewSession', isSecure: true, contentType: 'application/json'
        };
        let headers = new HttpHeaders();
        headers = this.getHeadersData(urlOptions);
        let options = { headers: headers };
        let endPointUrl = this.constructUrl(urlOptions);
        this.http.post(endPointUrl, { 'renewSession': 'true' }, options)
        .pipe(map(res => {
                return res;
            }
            ))
            .subscribe(
                data => {
                    if (data['alightPersonSessionToken']) {
                        let tempToken = data['alightPersonSessionToken'];
                        if (tempToken !== null) {
                            this.domStorageFB.setItem('alightPersonSessionToken', tempToken, '', true);
                        }
                    } else {
                        let tempToken = data['alightSecureSessionToken'];
                        if (tempToken !== null) {
                            this.domStorageFB.setItem('alightSecureSessionToken', tempToken, '', true);
                        }
                    }
                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);
                    this.processloggingBufferedCalls();
                },
                error => {

                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);
                },
                () => {

                    this.domStorageFB.setItem('sessionRenewInProgress', 'false', '', true);
                }
            );
    }

    /**
     * Function for getting headers data
     * These header would be added for rest call from application.
     */

    /* istanbul ignore next */
    private getHeadersData(urlOptions: IUrlOptions) {
        let _headers = new HttpHeaders();
        try {
            if (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true))) {
                _headers = _headers.append('alightPersonSessionToken', this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true));
            } else {
                _headers = _headers.append('alightSecureSessionToken', this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true));
            }

        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('LoggingService::getHeadersData Error while setting alightSecureSessionToken header ', error);
            }
        }
        try {
            // Add UxUniquePageId, PageName and DeviceType to channelRequestData
            this.appUtility.updateChannelRequestData({
                'uxPageRequestId': this.domStorageFB.getItem('uniquePageId', '', true),
                'pageName': this.appUtility.getPageNameFromURL(),
                'deviceType': this.domStorageFB.getItem('upointDeviceType', '', true),
                'sessionCreatedTimestamp': this.domStorageFB.getItem('sessionCreatedTimestamp', 'sessionStorage', true),
                'widgetName': null
            });

            _headers = _headers.append('alightRequestHeader', this.domStorageFB.getItem('alightRequestHeader'));
            _headers = _headers.append('Content-Type', urlOptions.contentType);
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('LoggingService::getHeadersData Error while setting alightRequestHeader header ', error);
            }
        }
        return _headers;
    }

    /**
     * processloggingBufferedCalls.
     * Function for processing Buffered Logging calls.
     */

    /* istanbul ignore next */
    private processloggingBufferedCalls() {
        this.renewSessionBufferLoggingCalls.forEach((aCall: {
            urlOptions: IUrlOptions,
            logData: any
        }) => {
            this.sendLogDataToServer(aCall.logData);
        });
        this.renewSessionBufferLoggingCalls = [];
    }

    /**
     * Method for logging Thrive Page Usage
     */
    /* istanbul ignore next */
    _uxRenderEvent(message: any, resourceName: string, resourceInstance: string, userAction: string, severityLevel: string, requestType: string = LoggingConstants.LOGGING_DEFAULT_VALUE_LABEL) {
        if (this.isValidLogLevel(severityLevel, LoggingConstants.EVENT_TYPE__PAGEUSAGE_LABEL)) {
            let logArray = [];
            let logdata = [];
            if (message !== null && message.length > 0) {
                let consumerReferenceId = this.uuid();
                for (let i = 0; i < message.length; i++) {
                    for (let j = 0; j < message[i].length; j++) {
                        logdata = this.generateLogData(LoggingConstants.EVENT_TYPE__PAGEUSAGE_LABEL, message[i][j].message, resourceName, resourceInstance, severityLevel, userAction, requestType, consumerReferenceId,
                            '', '', '',
                            {
                                'ActionType': 'RENDER',
                                'ActionTarget': '',
                                'Position': message[i][j].position,
                                'Domain': message[i][j].domain,
                                'UniqueIdentifier': message[i][j].uniqueIdentifier,
                                'ResourceInstance': message[i][j].resourceInstance,
                                'Container': message[i][j].container,
                                'ContentType': message[i][j].contentType
                            }

                        );
                        if (logdata.length > 0) {
                            logArray.push(logdata[0]);
                        }
                    }
                }
            }
            if (logArray.length > 0) {
                this.sendLogDataToServer(logArray);
            }

        }
    }
}
